import React from 'react'
import ReactNotifications from 'react-notifications-component'
import { flowRight } from 'lodash'
import { graphql } from '@apollo/client/react/hoc'
import objectHash from 'object-hash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { clearNotifications } from 'lib/utils/store/notifications'

import getNotifications from 'graphql/navigation/getNotifications.gql'

import './notifications.pcss'

export const NOTIFICATION_TYPE = {
    SUCCESS: 'success',
    DEFAULT: 'default',
    WARNING: 'warning',
    INFO: 'info',
    DANGER: 'danger',
}

class Notifications extends React.Component {
    openNotifications = {}

    constructor () {
        super()

        this.notificationDOMRef = React.createRef()
    }

    componentDidUpdate () {
        const { notifications } = this.props

        if (notifications.length > 0) {
            notifications.forEach(item => this.displayNotification(item))
            clearNotifications()
        }
    }

    getNotificationId (notification) {
        return objectHash(notification)
    }

    displayNotification = (notification) => {
        const { type, title, message } = notification

        const id = this.getNotificationId(notification)

        // prevent opening the same notification multiple times
        if (this.openNotifications[id]) return false

        this.openNotifications[id] = notification

        const negative = [NOTIFICATION_TYPE.WARNING, NOTIFICATION_TYPE.DANGER].includes(type)

        const animationIn = negative ? ['animated', 'fadeInDown'] : ['animated', 'fadeInDown']

        this.notificationDOMRef.current.addNotification({
            id: id,
            title: title,
            message: message,
            // content: <div className="notification-content">{message}</div>,
            type: type,
            insert: 'bottom',
            container: 'top-center',
            animationIn: animationIn,
            animationOut: ['animated', 'fadeOut'],
            dismiss: { duration: 8000 },
            dismissable: { click: true },
            width: 400,
        })
    }

    handleNotificationRemoval = (id) => {
        delete this.openNotifications[id]
    }

    render () {
        return (
            <ReactNotifications
                ref={this.notificationDOMRef}
                onNotificationRemoval={this.handleNotificationRemoval}
            />
        )
    }
}

export default flowRight(
    withErrorBoundaryNoRender,
    graphql(getNotifications, {
        name: 'notifications',
        props: (data) => ({
            notifications: data.notifications.notifications,
        }),
    }),
)(Notifications)
